module.exports = __webpack_public_path__ + "img/ENCANTA.638612dd.png";